import { useContext } from "react";
import { rootStoreContext } from "../Stores";

// custom hook to acces store
export const useStore = () => useContext(rootStoreContext);
